/**
 * 通知ダイアログController
 */
export class NoticeDlgController {

    /**
     * ダイアログのタイトル
     */
    private title: string;

    /**
     * ダイアログのメッセージ
     */
    private msg: string;

    /**
     * コンストラクタ
     * パラメータでプロパティの定義を実施
     * @param {ng.ui.bootstrap.IModalServiceInstance} $uibModalInstance UI Bootstrapのモーダル部品
     * @param {[string, string]} items ダイアログに表示するタイトルとメッセージ
     */
    /* @ngInject */
    constructor($uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, items: [string, string]) {
        this.title = items[0];
        this.msg = items[1];
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/extends_fw/controller/NoticeDlgController.ts
 **/